import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import Draggable from "react-draggable";
import { toPng } from "html-to-image";
import toast, { Toaster } from "react-hot-toast";
import jsPDF from "jspdf";
// IMPORTANTE: Use o import padrão para evitar conflitos de versão

import * as pdfjsLib from "pdfjs-dist";



// worker local (mais seguro)

pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.js";

import api from "../services/api";

// Modelos e Templates
import { botoesGrunge } from "../templates/ModelosBotoes";
import { templatesCardapio } from "../templates/templatesIndex";

// Estilos
import "../styles/EditorCardapio.css";

export default function EditorCardapio() {
  const { id } = useParams();
  const canvasRef = useRef(null);
  const bgInputRef = useRef(null);
  const imageElementRef = useRef(null);
  const fileImportRef = useRef(null);
  const pdfImportRef = useRef(null);

  // Estados principais
  const [pages, setPages] = useState({ 0: [] });
  const [currentPage, setCurrentPage] = useState(0);
  const [selected, setSelected] = useState(null);
  const [dadosEstabelecimento, setDadosEstabelecimento] = useState(null);
  const [activeAccordion, setActiveAccordion] = useState('templates');

  const [config, setConfig] = useState({
    cor_primaria: "#111111",
    fundo_custom: "",
    tipo_fundo: "solido",
    gradiente_cor1: "#1e293b",
    gradiente_cor2: "#0f172a",
    gradiente_angulo: 135,
    filtro_brilho: 100,
    filtro_blur: 0,
    bg_size: "cover",
    bg_pos_x: 50,
    bg_pos_y: 50,
    fonte_principal: "Inter"
  });

  // --- CARREGAMENTO INICIAL ---
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&family=Oswald:wght@400;700&family=Playfair+Display:wght@400;700;900&family=Montserrat:wght@400;700;900&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    if (id) {
      // Dados do cliente
      api.get(`/cardapio/estabelecimento/${id}`)
        .then(res => setDadosEstabelecimento(res.data))
        .catch(() => toast.error("Erro ao carregar dados do cliente."));

      // Layout persistido
      api.get(`/cardapio/layout/${id}`)
        .then(res => {
          if (res?.data) {
            // Proteção para Config
            let cfg = res.data.config;
            if (typeof cfg === 'string') {
              try { cfg = JSON.parse(cfg); } catch(e) { cfg = config; }
            }
            if (cfg) setConfig(prev => ({ ...prev, ...cfg }));

            // Proteção para Elementos
            let elementosRaw = res.data.elementos;
            if (typeof elementosRaw === 'string') {
              try { elementosRaw = JSON.parse(elementosRaw); } catch(e) { elementosRaw = { 0: [] }; }
            }
            
            // Sanitização: Garante que elementos carregados tenham propriedades de transformação
            const sanitized = {};
            Object.keys(elementosRaw).forEach(pg => {
              sanitized[pg] = elementosRaw[pg].map(el => ({
                ...el,
                estilo: { rotate: 0, scaleX: 1, scaleY: 1, sombraX: 0, sombraY: 0, sombraBlur: 0, sombraCor: "#000000", ...el.estilo }
              }));
            });
            setPages(sanitized);
          }
        })
        .catch(() => console.log("Nenhum layout prévio encontrado."));
    }
  }, [id]);

  // --- UTILITÁRIOS ---
  const generateId = () => `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  // --- FUNÇÕES DE ELEMENTOS ---
  const injectElement = (tipo, conteudo, estiloPersonalizado = {}) => {
    const novo = {
      id: generateId(),
      tipo, 
      conteudo, 
      pos_x: 50, 
      pos_y: 100,
      estilo: {
        fontSize: tipo === 'texto' ? 16 : undefined,
        color: "#ffffff",
        padding: "4px",
        display: "inline-block",
        width: tipo === 'imagem' ? 150 : "fit-content",
        fontFamily: "Inter",
        fontWeight: "normal",
        fontStyle: "normal",
        zIndex: (pages[currentPage]?.length || 0) + 1,
        sombraX: 0, sombraY: 0, sombraBlur: 0, sombraCor: "#000000",
        filtroEspecial: "none",
        rotate: 0,
        scaleX: 1,
        scaleY: 1,
        ...estiloPersonalizado
      }
    };
    setPages(prev => ({ ...prev, [currentPage]: [...(prev[currentPage] || []), novo] }));
    toast.success("Adicionado!");
  };

  const updateStyle = (key, value) => {
    setPages(prev => ({
      ...prev,
      [currentPage]: prev[currentPage].map(item => 
        item.id === selected ? { ...item, estilo: { ...item.estilo, [key]: value } } : item
      )
    }));
  };

  const updateContent = (id, newContent) => {
    setPages(prev => ({
      ...prev,
      [currentPage]: prev[currentPage].map(item => item.id === id ? { ...item, conteudo: newContent } : item)
    }));
  };

  const duplicateElement = () => {
    const item = pages[currentPage].find(el => el.id === selected);
    if (!item) return;
    const novo = { ...item, id: generateId(), pos_x: item.pos_x + 20, pos_y: item.pos_y + 20 };
    setPages(prev => ({ ...prev, [currentPage]: [...prev[currentPage], novo] }));
    toast.success("Duplicado!");
  };

  const deleteElement = () => {
    setPages(prev => ({ ...prev, [currentPage]: prev[currentPage].filter(e => e.id !== selected) }));
    setSelected(null);
  };

  // --- FUNÇÕES DE PÁGINA ---
  const addPage = () => {
    const newIdx = Object.keys(pages).length;
    setPages(prev => ({ ...prev, [newIdx]: [] }));
    setCurrentPage(newIdx);
  };

  const removePage = () => {
    if (Object.keys(pages).length <= 1) return toast.error("Mínimo de 1 página.");
    const newPages = { ...pages };
    delete newPages[currentPage];
    const reindexed = {};
    Object.values(newPages).forEach((val, i) => { reindexed[i] = val; });
    setPages(reindexed);
    setCurrentPage(0);
  };


const handleImageElementUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => injectElement("imagem", ev.target.result, { width: 200 });
    reader.readAsDataURL(file);
  };

  const handleDataImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      ev.target.result.split("\n").forEach(linha => {
        if(linha.trim()) injectElement("texto", linha.trim(), { fontSize: 14 });
      });
    };
    reader.readAsText(file);
  };

  const getFilterStyle = (tipo) => {
    switch (tipo) {
      case "giz": return "grayscale(1) contrast(200%) brightness(1.2)";
      case "fumaca": return "blur(1px) brightness(1.1) opacity(0.9)";
      case "pb": return "grayscale(1)";
      default: return "none";
    }
  };

const handlePdfImport = async (e) => {

  const file = e.target.files[0];
  if (!file) return;

  const loading = toast.loading("Importando PDF...");

  try {

    const buffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: buffer }).promise;

    const novasPaginas = {};

    for (let p = 1; p <= pdf.numPages; p++) {

      const page = await pdf.getPage(p);

      const viewport = page.getViewport({ scale: 1 });

      const larguraEditor = 380;
      const escala = larguraEditor / viewport.width;

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = viewport.width;
      canvas.height = viewport.height;

      await page.render({
        canvasContext: ctx,
        viewport
      }).promise;

      const bgImage = canvas.toDataURL("image/png");

      const textContent = await page.getTextContent();

      const elementos = [];

      // background da página
      elementos.push({
        id: Date.now() + Math.random(),
        tipo: "imagem",
        conteudo: bgImage,
        pos_x: 0,
        pos_y: 0,
        estilo: {
          width: larguraEditor,
          zIndex: 0,
          pointerEvents: "none"
        }
      });

      textContent.items.forEach((item) => {

        const texto = item.str.trim();
        if (!texto) return;

        const tx = pdfjsLib.Util.transform(
          viewport.transform,
          item.transform
        );

        const x = tx[4] * escala;
        const y = (viewport.height - tx[5]) * escala;

        elementos.push({
          id: Date.now() + Math.random(),
          tipo: "texto",
          conteudo: texto,
          pos_x: x,
          pos_y: y,
          estilo: {
            fontSize: item.height * escala,
            color: "#ffffff",
            fontFamily: "Inter",
            zIndex: 5,
            width: "fit-content"
          }
        });

      });

      novasPaginas[p - 1] = elementos;

    }

    setPages(novasPaginas);
    setCurrentPage(0);

    toast.dismiss(loading);
    toast.success(`PDF importado (${pdf.numPages} páginas)`);

  } catch (err) {

    console.error(err);
    toast.dismiss(loading);
    toast.error("Erro ao importar PDF");

  }

};

  // --- HANDLERS DE TEMPLATE E PDF ---
  const loadTemplate = (tipo) => {
    if (!window.confirm("Isso apagará a página atual. Confirmar?")) return;

    const template = templatesCardapio[tipo];

    if (!template) {
      toast.error("Template não encontrado");
      return;
    }

    setConfig(prev => ({ ...prev, ...template.config }));

    const novosElementos = template.elementos.map(el => ({
      ...el,
      id: generateId(),
      estilo: {
        rotate: 0, scaleX: 1, scaleY: 1,
        sombraX: 0, sombraY: 0, sombraBlur: 0, sombraCor: "#000000",
        ...(el.estilo || {})
      }
    }));

    setPages(prev => ({ ...prev, [currentPage]: novosElementos }));
    toast.success(`Template ${tipo} carregado`);
  };



  
  const saveLayout = async () => {
    const loading = toast.loading("Salvando...");
    try {
      await api.post(`/cardapio/layout/${id}`, { config, elementos: pages });
      toast.dismiss(loading);
      toast.success("Salvo!");
    } catch (err) { 
      toast.dismiss(loading); 
      toast.error("Erro ao salvar."); 
    }
  };

  const exportPDFCompleto = async () => {
    const loading = toast.loading("Gerando PDF...");
    const pdf = new jsPDF("p", "mm", [105, 180]);
    const original = currentPage;
    
    try {
      for (let i = 0; i < Object.keys(pages).length; i++) {
        setCurrentPage(i);
        await new Promise(r => setTimeout(r, 600));
        const data = await toPng(canvasRef.current, { pixelRatio: 2 });
        if (i > 0) pdf.addPage([105, 180], "p");
        pdf.addImage(data, "PNG", 0, 0, 105, 180);
      }
      pdf.save(`cardapio_${id}.pdf`);
    } catch (e) {
      toast.error("Erro ao exportar.");
    } finally {
      setCurrentPage(original);
      toast.dismiss(loading);
    }
  };

  const current = (pages[currentPage] || []).find(e => e.id === selected);


return (
    <div className="editor-page">
      <Toaster />
      
      <aside className="editor-sidebar">
        <h2 className="editor-brand">Universo <span>Mídia</span></h2>

        {/* NAVEGAÇÃO DE PÁGINAS */}
        <div className="pagination-wrapper">
          <div className="page-indicator">
            <button 
              className="page-nav-btn" 
              onClick={() => setCurrentPage(p => Math.max(0, p - 1))}
              disabled={currentPage === 0}
            >
              <span className="icon">❮</span>
            </button>
            
            <div className="page-counter">
              <span className="current-num">{currentPage + 1}</span>
              <span className="divider">/</span>
              <span className="total-num">{Object.keys(pages).length}</span>
            </div>

            <button 
              className="page-nav-btn" 
              onClick={() => setCurrentPage(p => Math.min(Object.keys(pages).length - 1, p + 1))}
              disabled={currentPage === Object.keys(pages).length - 1}
            >
              <span className="icon">❯</span>
            </button>
          </div>
          
          <div className="page-actions">
            <button className="btn-add-page" onClick={addPage}>
              <span className="plus-icon">+</span> Nova Página
            </button>
            <button className="btn-remove-page" onClick={removePage} title="Excluir página atual">
              <span className="trash-icon">🗑</span>
            </button>
          </div>
        </div>

       {/* MODELOS PRONTOS - DINÂMICO */}
        <div className="accordion-item">
          <button className="accordion-header" onClick={() => setActiveAccordion(activeAccordion === 'templates' ? null : 'templates')}>
            📋 Modelos Prontos {activeAccordion === 'templates' ? '▲' : '▼'}
          </button>
          {activeAccordion === 'templates' && (
            <div className="accordion-content">
              {/* MAPEAMENTO DINÂMICO DOS TEMPLATES */}
              {Object.keys(templatesCardapio).map((key) => (
                <button 
                  key={key} 
                  className="btn-piece" 
                  onClick={() => loadTemplate(key)}
                >
                  {/* Tenta pegar o nome do template, senão usa a chave com a primeira letra maiúscula */}
                  {templatesCardapio[key].nome || key.toUpperCase()}
                </button>
              ))}
              
              {Object.keys(templatesCardapio).length === 0 && (
                <p className="prop-label-mini" style={{textAlign: 'center'}}>Nenhum template encontrado.</p>
              )}
            </div>
          )}
        </div>

        {/* ESTILOS DE BOTÕES & PLACAS (GRUNGE) */}
        <div className="accordion-item">
          <button className="accordion-header" onClick={() => setActiveAccordion(activeAccordion === 'botoes' ? null : 'botoes')}>
            🖌️ Estilos de Botões & Placas {activeAccordion === 'botoes' ? '▲' : '▼'}
          </button>
          {activeAccordion === 'botoes' && (
            <div className="accordion-content">
              <div className="grid-componentes-import" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', padding: '10px' }}>
                {botoesGrunge && botoesGrunge.map((item) => (
                  <button
                    key={item.id}
                    style={{ 
                      backgroundColor: item.estilo.backgroundColor === 'transparent' ? '#334155' : item.estilo.backgroundColor,
                      color: item.estilo.color,
                      border: 'none',
                      padding: '8px',
                      borderRadius: '4px',
                      fontSize: '10px',
                      cursor: 'pointer',
                      fontWeight: 'bold',
                      minHeight: '40px'
                    }}
                    onClick={() => injectElement(item.tipo, item.conteudo, item.estilo)}
                  >
                    {item.nome}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* CABEÇALHO DINÂMICO */}
        <div className="accordion-item">
          <button className="accordion-header" onClick={() => setActiveAccordion(activeAccordion === 'cabecalho' ? null : 'cabecalho')}>
            🏛️ Cabeçalho {activeAccordion === 'cabecalho' ? '▲' : '▼'}
          </button>
          {activeAccordion === 'cabecalho' && dadosEstabelecimento && (
            <div className="accordion-content">
              <button className="btn-piece" onClick={() => injectElement("texto", dadosEstabelecimento.nome?.toUpperCase(), { fontSize: 24, fontWeight: "900", color: "#f1c40f", fontFamily: "Oswald" })}>Nome da Empresa</button>
              <button className="btn-piece" onClick={() => injectElement("texto", dadosEstabelecimento.endereco, { fontSize: 11, opacity: 0.8 })}>📍 Endereço</button>
              <button className="btn-piece" onClick={() => injectElement("texto", `WhatsApp: ${dadosEstabelecimento.whatsapp}`, { fontSize: 13, color: "#2ecc71", fontWeight: "bold" })}>📱 WhatsApp</button>
            </div>
          )}
        </div>
         {/* 2. FUNDOS */}

        <div className="accordion-item">

          <button className="accordion-header" onClick={() => setActiveAccordion(activeAccordion === 'fundo' ? null : 'fundo')}>

            🎨 Fundo da Página {activeAccordion === 'fundo' ? '▲' : '▼'}

          </button>

          {activeAccordion === 'fundo' && (

            <div className="accordion-content">

              <select className="prop-select" value={config.tipo_fundo} onChange={e => setConfig({ ...config, tipo_fundo: e.target.value })}>

                <option value="solido">Cor Sólida</option>

                <option value="gradiente">Gradiente Dinâmico</option>

                <option value="imagem">Imagem de Fundo</option>

              </select>



              {config.tipo_fundo === "gradiente" && (

                <div style={{ marginTop: '10px' }}>

                  <input type="range" min="0" max="360" value={config.gradiente_angulo} onChange={e => setConfig({ ...config, gradiente_angulo: e.target.value })} style={{ width: '100%' }} />

                  <div style={{ display: 'flex', gap: '5px', marginTop: '5px' }}>

                    <input type="color" value={config.gradiente_cor1} onChange={e => setConfig({ ...config, gradiente_cor1: e.target.value })} style={{ flex: 1, height: '30px' }} />

                    <input type="color" value={config.gradiente_cor2} onChange={e => setConfig({ ...config, gradiente_cor2: e.target.value })} style={{ flex: 1, height: '30px' }} />

                  </div>

                </div>

              )}



              {config.tipo_fundo === "imagem" && (

                <div style={{ marginTop: '10px' }}>

                  <button className="btn-piece" onClick={() => bgInputRef.current.click()}>📷 Upload Foto</button>

                  <label className="prop-label-mini">Zoom</label>

                  <select className="prop-select" value={config.bg_size} onChange={e => setConfig({ ...config, bg_size: e.target.value })}>

                    <option value="cover">Preencher</option>

                    <option value="contain">Ajustar</option>

                    <option value="150%">150%</option>

                    <option value="200%">200%</option>

                  </select>

                </div>

              )}

              <input type="file" ref={bgInputRef} hidden onChange={(e) => {

                const reader = new FileReader();

                reader.onload = (ev) => setConfig({ ...config, fundo_custom: ev.target.result, tipo_fundo: 'imagem' });

                if(e.target.files[0]) reader.readAsDataURL(e.target.files[0]);

              }} />

            </div>

          )}

        </div>



        {/* INSERIR ITENS */}
        <div className="accordion-item">
          <button className="accordion-header" onClick={() => setActiveAccordion(activeAccordion === 'itens' ? null : 'itens')}>
            📝 Inserir Itens {activeAccordion === 'itens' ? '▲' : '▼'}
          </button>
          {activeAccordion === 'itens' && (
            <div className="accordion-content">
              <button className="btn-piece" onClick={() => injectElement("texto", "CATEGORIA", { fontSize: 22, color: "#f1c40f", fontWeight: "bold" })}>📁 Categoria</button>
              <button className="btn-piece" onClick={() => injectElement("texto", "Item .... R$ 00,00")}>📝 Item Texto</button>
              <button className="btn-piece" onClick={() => imageElementRef.current.click()}>🖼️ Inserir Imagem</button>
              <input type="file" ref={imageElementRef} hidden accept="image/*" onChange={handleImageElementUpload} />
              
              <button className="btn-piece" onClick={() => pdfImportRef.current.click()}>📑 Importar PDF</button>
              <input type="file" ref={pdfImportRef} hidden accept="application/pdf" onChange={handlePdfImport} />

              <div className="icon-grid">
                {["🍕", "🍔", "🥤", "📞", "📍", "✂️", "🍺", "🍦"].map(icon => (
                  <button key={icon} onClick={() => injectElement("texto", icon, { fontSize: 40 })} className="icon-btn">{icon}</button>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="export-area">
          <button className="btn-pdf" onClick={exportPDFCompleto}>Exportar PDF Completo</button>
          <button className="btn-save" onClick={saveLayout}>Salvar Projeto</button>
        </div>
      </aside>

      <main className="canvas-area" onClick={() => setSelected(null)}>
        <div
          ref={canvasRef}
          className="canvas-container"
          style={{
            backgroundColor: config.cor_primaria,
            backgroundImage: config.tipo_fundo === "gradiente"
              ? `linear-gradient(${config.gradiente_angulo}deg, ${config.gradiente_cor1} 0%, ${config.gradiente_cor2} 100%)`
              : (config.tipo_fundo === "imagem" ? `url(${config.fundo_custom})` : "none"),
            backgroundSize: config.bg_size,
            backgroundPosition: `${config.bg_pos_x}% ${config.bg_pos_y}%`,
            backgroundRepeat: "no-repeat",
            filter: config.tipo_fundo === "imagem" ? `brightness(${config.filtro_brilho}%) blur(${config.filtro_blur}px)` : "none"
          }}
        >
          {(pages[currentPage] || []).map(el => (
            <Draggable
              key={el.id}
              position={{ x: el.pos_x, y: el.pos_y }}
              onStop={(e, data) => {
                setPages(prev => ({
                  ...prev,
                  [currentPage]: prev[currentPage].map(item => item.id === el.id ? { ...item, pos_x: data.x, pos_y: data.y } : item)
                }));
              }}
              bounds="parent"
            >
              <div
                onClick={(e) => { e.stopPropagation(); setSelected(el.id); }}
                className={`element-wrapper ${selected === el.id ? 'element-selected' : ''}`}
                style={{ 
                  zIndex: el.estilo.zIndex,
                  // AQUI ESTAVA O ERRO: Aplicando as transformações de escala e rotação no wrapper
                  transform: `rotate(${el.estilo.rotate || 0}deg) scale(${el.estilo.scaleX || 1}, ${el.estilo.scaleY || 1})`,
                  transformOrigin: 'center center',
                  position: 'absolute'
                }}
              >
                {el.tipo === 'texto' ? (
                  <div
                    contentEditable suppressContentEditableWarning
                    onBlur={(e) => updateContent(el.id, e.target.innerText)}
                    style={{
                      ...el.estilo,
                      // Importante: Manter o transform interno como 'none' para não bugar a escala ao editar o texto
                      transform: 'none',
                      whiteSpace: 'pre-wrap', outline: 'none',
                      textShadow: `${el.estilo.sombraX}px ${el.estilo.sombraY}px ${el.estilo.sombraBlur}px ${el.estilo.sombraCor}`
                    }}
                  >
                    {el.conteudo}
                  </div>
                ) : (
                  <img 
                    src={el.conteudo} 
                    alt="elem" 
                    draggable="false" 
                    style={{ 
                        width: el.estilo.width, 
                        height: 'auto', 
                        filter: getFilterStyle(el.estilo.filtroEspecial),
                        boxShadow: `${el.estilo.sombraX}px ${el.estilo.sombraY}px ${el.estilo.sombraBlur}px ${el.estilo.sombraCor}`
                    }} 
                  />
                )}
              </div>
            </Draggable>
          ))}
        </div>
      </main>

      <aside className="editor-props">
        <p className="prop-label">Propriedades</p>
        {current ? (
          <>
            <div className="prop-row">
              <button className="btn-piece" onClick={duplicateElement}>👯 Duplicar</button>
            </div>

            <label className="prop-label-mini">Cor do Texto</label>
            <input type="color" className="prop-color-picker" value={current.estilo.color || "#ffffff"} onChange={e => updateStyle("color", e.target.value)} />

            <label className="prop-label-mini">Fonte</label>
            <select className="prop-select" value={current.estilo.fontFamily} onChange={e => updateStyle("fontFamily", e.target.value)}>
              <option value="Inter">Inter</option>
              <option value="Oswald">Oswald</option>
              <option value="Playfair Display">Playfair</option>
              <option value="Montserrat">Montserrat</option>
            </select>

            <label className="prop-label-mini">Tamanho / Largura</label>
            <input type="range" min="8" max="400" value={current.tipo === 'texto' ? current.estilo.fontSize : current.estilo.width}
              onChange={e => updateStyle(current.tipo === 'texto' ? "fontSize" : "width", parseInt(e.target.value))} style={{ width: '100%' }} />

            {/* CONTROLES DE TRANSFORMAÇÃO LIVRE */}
            <div style={{ marginTop: '15px', borderTop: '1px solid #334155', paddingTop: '10px' }}>
              <label className="prop-label-mini">Inclinar / Rotacionar ({current.estilo.rotate || 0}°)</label>
              <input 
                type="range" min="-180" max="180" 
                value={current.estilo.rotate || 0} 
                onChange={e => updateStyle("rotate", parseInt(e.target.value))} 
                style={{ width: '100%' }} 
              />
              
              <div style={{ display: 'flex', gap: '8px', marginTop: '10px' }}>
                <div style={{ flex: 1 }}>
                  <label className="prop-label-mini">Alongar ↔</label>
                  <input 
                    type="range" min="0.1" max="4" step="0.1" 
                    value={current.estilo.scaleX || 1} 
                    onChange={e => updateStyle("scaleX", parseFloat(e.target.value))} 
                    style={{ width: '100%' }} 
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label className="prop-label-mini">Esticar ↕</label>
                  <input 
                    type="range" min="0.1" max="4" step="0.1" 
                    value={current.estilo.scaleY || 1} 
                    onChange={e => updateStyle("scaleY", parseFloat(e.target.value))} 
                    style={{ width: '100%' }} 
                  />
                </div>
              </div>
            </div>

            <div className="format-btn-group" style={{ marginTop: '15px' }}>
              <button className="format-btn" style={{ backgroundColor: current.estilo.fontWeight === 'bold' ? '#3b82f6' : '#1e293b' }}
                onClick={() => updateStyle('fontWeight', current.estilo.fontWeight === 'bold' ? 'normal' : 'bold')}>B</button>
              <button className="format-btn" style={{ backgroundColor: current.estilo.fontStyle === 'italic' ? '#3b82f6' : '#1e293b' }}
                onClick={() => updateStyle('fontStyle', current.estilo.fontStyle === 'italic' ? 'normal' : 'italic')}>I</button>
              <button className="format-btn" onClick={() => updateStyle('zIndex', (current.estilo.zIndex || 0) + 1)}>⬆️</button>
              <button className="format-btn" onClick={() => updateStyle('zIndex', Math.max(0, (current.estilo.zIndex || 0) - 1))}>⬇️</button>
            </div>

            <p className="prop-label-mini">Sombra (X, Blur, Cor)</p>
            <input type="range" min="-20" max="20" value={current.estilo.sombraX} onChange={e => updateStyle("sombraX", parseInt(e.target.value))} style={{ width: '100%' }} />
            <input type="range" min="0" max="20" value={current.estilo.sombraBlur} onChange={e => updateStyle("sombraBlur", parseInt(e.target.value))} style={{ width: '100%' }} />
            <input type="color" className="prop-color-picker" value={current.estilo.sombraCor} onChange={e => updateStyle("sombraCor", e.target.value)} />

            <button className="btn-delete" style={{ marginTop: '20px' }} onClick={deleteElement}>Remover Item</button>
          </>
        ) : <p className="prop-label-mini" style={{textAlign: 'center' }}>Selecione algo para editar</p>}
      </aside>
    </div>
  );
}